export default {
    methods: {
        updateDeliveryMode: function (delivery_mode) {
            let formData = new FormData();
            formData.append("delivery_mode", delivery_mode);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/delivery-mode", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateTableNumber: function (table_number) {
            if (!table_number) {
                return false;
            }
            this.errors.table_number = null;
            let formData = new FormData();
            formData.append("table_number", table_number);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/table-number", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateSpecialInstructions: function (special_instructions) {
            if (!special_instructions) {
                return false;
            }
            let formData = new FormData();
            formData.append("special_instructions", special_instructions);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/special-instructions", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateReceiptEmail: function (receipt_email) {
            if (!receipt_email) {
                return false;
            }
            localStorage.customerEmail = receipt_email;
            this.errors = {};
            let formData = new FormData();
            formData.append("receipt_email", receipt_email);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/receipt-email", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateCustomerName: function (customer_name) {
            if (!customer_name) {
                return false;
            }
            localStorage.customerName = customer_name;
            this.errors = {};
            let formData = new FormData();
            formData.append("customer_name", customer_name);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/customer-name", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateCustomerPhone: function (customer_phone) {
            customer_phone = Number(customer_phone);
            if (!customer_phone) {
                return false;
            }
            localStorage.customerPhone = customer_phone;
            this.errors = {};
            let formData = new FormData();
            formData.append("customer_phone", customer_phone);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/customer-phone", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateCustomerCountryCode: function (customer_country_code) {
            if (!customer_country_code) {
                return false;
            }
            localStorage.customerCountryCode = customer_country_code;
            this.errors = {};
            let formData = new FormData();
            formData.append("customer_country_code", customer_country_code);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/customer-country-code", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        updateSelectedTipRate: function (rate) {
            this.errors = {};
            let formData = new FormData();
            formData.append("tip_rate", rate);
            formData.append("_method", "PATCH");

            axios
                .post("/api/customer/cart/tip-rate", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        this.processing = false;
                        this.error = null;
                        this.getCart();
                    },
                    (error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors;
                    }
                );
        },
        acknowledgeSuccess: function (session_id) {
            this.processing = true;
            let formData = new FormData();
            formData.append("session_id", session_id);
            axios
                .post("/api/customer/checkout/success-acknowledge", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (response) => {
                        location.href = "/" + this.rawMenu.user.slug;
                    },
                    (error) => {
                        location.href = "/" + this.rawMenu.user.slug;
                    }
                );
        },
    },
    computed: {
        cartItems: function () {
            let items = [];
            _.forEach(this.cart.items, function (iValue, iKey) {
                items.push(JSON.parse(iValue));
            });
            return items;
        },
        cartDeliveryMode: function () {
            return this.cart.delivery_mode;
        },
        cartTableNumber: function () {
            if (!this.cart.table_number) {
                return "";
            }
            return this.cart.table_number;
        },
        orderAmount: function () {
            let amount = 0;
            this.cartItemCount = 0;
            let _self = this;
            _.forEach(this.cartItems, function (iValue, iKey) {
                let itemAmount = 0;
                _.forEach(iValue.prices, function (pValue, cKey) {
                    if (pValue.selected) {
                        itemAmount = itemAmount + pValue.amount;
                    }
                });

                _.forEach(iValue.options, function (cValue, cKey) {
                    if (cValue.selected) {
                        itemAmount = itemAmount + cValue.amount;
                    }
                });
                _.forEach(iValue.option_groups, function (cValue, cKey) {
                    _.forEach(cValue.options, function (oValue, cKey) {
                        if (oValue.selected) {
                            itemAmount = itemAmount + oValue.amount;
                        }
                    });
                });
                itemAmount = itemAmount * iValue.quantity;
                amount = amount + itemAmount;
                _self.cartItemCount += iValue.quantity;
            });

            return amount;
        },
    },
};
